import { ChangeEvent } from 'react';
import { Input } from 'antd';
import { NumberFIeldProps } from '../Fields';
import { useFieldOperations } from '../hooks/useFieldOperations';

export const NumberField = ({
	disabled,
	fieldValue,
	forwardedRef,
	required,
	validations,
	onChange,
	onCancel,
	className,
	dataTestId,
	fieldType,
}: NumberFIeldProps) => {
	const { inputValue, handleOnChange, handleOnBlur, handleKeyDown } = useFieldOperations(
		fieldType,
		fieldValue ?? 0,
		required,
		validations,
		onChange,
		onCancel
	);
	const numberInputOnChange = (event: ChangeEvent<HTMLInputElement>) => {
		handleOnChange(Number(event.target.value ?? null));
	};

	return (
		<Input
			type="number"
			defaultValue={fieldValue ?? undefined}
			onChange={numberInputOnChange}
			style={{ flexGrow: 1, textAlignLast: 'right' }}
			disabled={disabled}
			autoFocus
			ref={forwardedRef}
			value={inputValue}
			onBlur={handleOnBlur}
			className={className}
			data-testid={dataTestId}
			onKeyDown={handleKeyDown}
		/>
	);
};
